

import { DepartmentModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { departmentsStore } from '@/libs/departments/+state/store';
import { tenantUsersStore } from '@/libs/tenants/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import DepartmentDialog from '../components/DepartmentDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        DepartmentDialog
    }
})
export default class Departments extends Page {

    get headers() {
        return [
            { text: this.$i18n.t('department.name'), value: 'name', align: 'left', sortable: false },
            { text: this.$i18n.t('department.parental'), value: 'id', align: 'left', sortable: false },
            { text: this.$i18n.t('department.managers'), value: 'id', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: DepartmentDialog;

    @Watch("itemsPerPage")
    itemsPerPageChanged (v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return departmentsStore.useGetter(CrudGetter.Pending);
    }
    
    get departments (): DepartmentModel[] {
        return [...departmentsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows (): number {
        return ({...departmentsStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    mounted () {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load () {
        departmentsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<DepartmentModel>({ field: "name", index: 1, order: "asc" }, this.getFilters());
    }

    open (item: DepartmentModel) {
        this.dialog.open(item.id!);
    }

    createItemClick () {
        this.dialog.open(Guid.EmptyGuid());
    }

    getParentalDepartmentById (id: string | null): DepartmentModel | undefined {
        return this.departments.find((x) => x.id == id);
    }

    getParentalDepartmentName (item: DepartmentModel): string {
        const directId = item.parentalDepartmentId ?? null;
        const relationId = directId
            ? directId
            : (Array.isArray(item.departmentParents)
                ? (item.departmentParents.find((p) => !!p.parentalDepartmentId)?.parentalDepartmentId ?? null)
                : null);
        if (!relationId) return '';
        const parent = this.getParentalDepartmentById(relationId);
        return parent?.name ?? '';
    }

    getDepartmentManagersNames(item: DepartmentModel): string[] {
        const managers = item.departmentManagers ?? [];
        // Prefer names from embedded tenantUser
        const namesFromModels = managers
            .map((m: any) => m?.tenantUser?.user?.displayName)
            .filter((x: any) => (x ?? '').length > 0) as string[];
        if (namesFromModels.length === managers.length) return namesFromModels;
        // Fallback: resolve via store cache if available
        const allUsers = (tenantUsersStore.useGetter(CrudGetter.Data) ?? []) as any[];
        return managers
            .map((m: any) => m?.tenantUser?.user?.displayName ?? (allUsers.find((u: any) => u.id == m.tenantUserId)?.user?.displayName ?? ''))
            .filter((x: any) => (x ?? '').length > 0);
    }

}
